import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import ru from './locales/ru.json';

export const languages = [
  { label: 'English', value: 'en', flag: 'us' },
  { label: 'Русский', value: 'ru', flag: 'ru' },
];

const SUPPORTED_LANGS = languages.map((item) => item.value);
const DEFAULT_LANG = 'en';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: DEFAULT_LANG,
    supportedLngs: SUPPORTED_LANGS,
    nonExplicitSupportedLngs: true,
    detection: {
      order: ['querystring', 'localStorage', 'navigator'],
      lookupQuerystring: 'lang',
      lookupLocalStorage: 'i18n-lang',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: en,
      },
      ru: {
        translation: ru,
      },
    },
  });

export function getLang() {
  return i18n.resolvedLanguage || DEFAULT_LANG;
}

export function resolveAuthLang(raw) {
  return SUPPORTED_LANGS.includes(raw) ? raw : getLang();
}

export function withAuthLang(path) {
  return `${path}?lang=${getLang()}`;
}

export default i18n;
